import React, { Fragment, useEffect, useState } from "react";
import {
  EuiButton,
  EuiFieldText,
  EuiForm,
  EuiFormRow,
  EuiFilePicker,
  EuiSpacer,
  EuiSuperSelect,
  EuiTextArea,
  EuiText,
  EuiEmptyPrompt,
  EuiComboBox,
  EuiFieldNumber,
} from "@elastic/eui";
import ntbc_logo from "./assets/ntbc-logo3.png";
import { Route, Switch, useHistory } from "react-router-dom";
import { db, storage } from "./firebase/firebase";
import { v4 } from "uuid";
import {
  categoryOptions,
  ipOptions,
  natureOfProjectOptions,
  purposeOptions,
  stageOptions,
} from "./Options";
import { applicationClass, formClass, logosClass, titleClass } from "./styles";
import { useForm } from "react-hook-form";
import { AdminLogin } from "./AdminLogin";
import { ApplicationSubmissions } from "./ApplicationSubmissions";
import { NIIHome } from "./NiiHome";

import axios from "axios";
const id = v4();

export const ApplicationForm: React.FC = () => {
  const history = useHistory();
  const [loading, setLoading] = useState<boolean>(false);
  const [category, setCategory] = useState<string>("");
  const [categoryErrors, setCategoryError] = useState(false);
  const [nopErrors, setNopErrors] = useState<boolean>(false);
  const [stageErrors, setStageErrors] = useState<boolean>(false);
  const [stage, setStage] = useState<string>("");

  const [ipErrors, setIpErrors] = useState<boolean>(false);
  const [ip, setIp] = useState<string>("");

  const [purposeErrors, setPurposeErrors] = useState<boolean>(false);
  const [purpose, setPurpose] = useState<string>("");

  const [isFormInvalid, setFormInvalid] = useState<boolean>(false);

  const [nopOptions] = useState(natureOfProjectOptions);
  const [selectedNopOptions, setSelectedNop] = useState([]);

  const onNopChange = (selectedNopOptions: any) => {
    setSelectedNop(selectedNopOptions);
  };

  const [imageFiles, setImageFiles] = useState<any>(null);
  const [imageUrl, setImageUrl] = useState<string>("");
  const [loadingImage, setLoadingImage] = useState<boolean>(false);

  const [nrcFiles, setNrcFiles] = useState<any>(null);
  const [nrcUrl, setNrcUrl] = useState<string>("");
  const [loadingNrc, setLoadingNrc] = useState<boolean>(false);

  const [ipFiles, setIpFiles] = useState<any>(null);
  const [ipUrl, setIpUrl] = useState<string>("");
  const [loadingIp, setLoadingIp] = useState<boolean>(false);

  const [regFiles, setRegFiles] = useState<any>(null);
  const [regUrl, setRegUrl] = useState<string>("");
  const [loadingReg, setLoadingReg] = useState<boolean>(false);

  const [formData, setFormData] = useState<any>(null);

  useEffect(() => {
    async function uploadNrc() {
      const url = await storage()
        .ref(`/tbdf-applications-2022/${id}/${nrcFiles[0].name}`)
        .put(nrcFiles[0])
        .then(async (x) => {
          const url = await x.ref.getDownloadURL();
          return url;
        });
      console.log("Url", url);
      setNrcUrl(url);
      setLoadingNrc(false);
    }
    if (loadingNrc) uploadNrc();
  }, [loadingNrc, nrcFiles]);

  useEffect(() => {
    async function uploadReg() {
      const url = await storage()
        .ref(`/tbdf-applications-2022/${id}/${regFiles[0].name}`)
        .put(regFiles[0])
        .then(async (x) => {
          const url = await x.ref.getDownloadURL();
          return url;
        });
      console.log("Url", url);
      setRegUrl(url);
      setLoadingReg(false);
    }
    if (loadingReg) uploadReg();
  }, [loadingReg, regFiles]);

  useEffect(() => {
    async function uploadImage() {
      const url = await storage()
        .ref(`/tbdf-applications-2022/${id}/${imageFiles[0].name}`)
        .put(imageFiles[0])
        .then(async (x) => {
          const url = await x.ref.getDownloadURL();
          return url;
        });
      console.log("Url", url);
      setImageUrl(url);
      setLoadingImage(false);
    }
    if (loadingImage) uploadImage();
  }, [loadingImage, imageFiles]);

  useEffect(() => {
    async function uploadIp() {
      const url = await storage()
        .ref(`/tbdf-applications-2022/${id}/${ipFiles[0].name}`)
        .put(ipFiles[0])
        .then(async (x) => {
          const url = await x.ref.getDownloadURL();
          return url;
        });
      console.log("Url", url);
      setIpUrl(url);
      setLoadingIp(false);
    }
    if (loadingIp) uploadIp();
  }, [loadingIp, ipFiles]);

  useEffect(() => {
    let isMounted = true;
    async function uploadProject() {
      await db()
        .collection("tbdf-applications-2026")
        .doc(id)
        .set({
          id,
          ...formData,
          imageUrl: imageUrl,
          nrcUrl: nrcUrl,
          ipUrl: ipUrl,
          regUrl: regUrl,
          category,
          selectedNopOptions,
          stage,
          ip,
          purpose,
          timestamp: db.Timestamp.now(),
        })
        .then((x) => {
          if (isMounted) history.push("/submitted");
        });
    }
    if (!loadingIp && !loadingNrc && !loadingReg && !loadingImage && formData) {
      uploadProject();
    }
    return () => {
      isMounted = false;
    };
  }, [
    formData,
    imageUrl,
    nrcUrl,
    ipUrl,
    regUrl,
    loadingIp,
    loadingNrc,
    loadingReg,
    loadingImage,
    category,
    ip,
    purpose,
    selectedNopOptions,
    stage,
    history,
  ]);

  const onImageChange = (fs: any) => {
    setImageFiles(fs);
  };

  const onNRCChange = (fs: any) => {
    setNrcFiles(fs);
  };
  const onIpChange = (fs: any) => {
    setIpFiles(fs);
  };
  const onRegChange = (fs: any) => {
    setRegFiles(fs);
  };

  const { register, handleSubmit, errors } = useForm();

  const onFormSubmit = async (data: any) => {
    if (!category) {
      setCategoryError(true);
      return;
    }

    if (!selectedNopOptions) {
      setNopErrors(true);
      return;
    }

    if (!stage) {
      setStageErrors(true);
      return;
    }

    if (!ip) {
      setIpErrors(true);
      return;
    }

    if (!purpose) {
      setPurposeErrors(true);
      return;
    }

    if (!nrcFiles) {
      setFormInvalid(true);
      return;
    }

    setLoading(true);
    setFormData(data);

    if (nrcFiles) {
      setLoadingNrc(true);
    }

    if (regFiles) {
      setLoadingReg(true);
    }

    if (imageFiles) {
      setLoadingImage(true);
    }

    if (ipFiles) {
      setLoadingIp(true);
    }

    localStorage.setItem("recipient", data.email);
    localStorage.setItem("recipeintsName", data.innovatorName);

    // history.push("/submitted");
  };

  return (
    <div className={applicationClass}>
      <div className={titleClass}>
        <EuiText style={{ maxWidth: 500 }}>
          <h2>Technology Business Development Fund</h2>
          <p>
            The applications should be submitted by 30 June 2026 at 23:59CAT.
            For more Information, call any of these numbers: +260 954 235 099
          </p>
        </EuiText>
        <EuiSpacer size="s" />
        <div className={logosClass}>
          <img
            src={ntbc_logo}
            alt="NTBC Logo"
            style={{ width: "auto", height: 64, marginRight: 4 }}
          />
        </div>
      </div>
      <EuiForm
        component="form"
        className={formClass}
        isInvalid={isFormInvalid}
        onSubmit={handleSubmit(onFormSubmit)}
      >
        <EuiText grow={false}>
          <h2>Background</h2>
          <hr />
          <EuiSpacer />
        </EuiText>
        <EuiFormRow
          label="Name of Project"
          helpText="Maximum of 50 words."
          fullWidth
        >
          <EuiFieldText
            name="name"
            inputRef={register({ required: true })}
            fullWidth
          />
        </EuiFormRow>
        <EuiFormRow
          fullWidth
          label="Name of Innovator"
          helpText="If you are in a group, add the name of the team leader."
        >
          <EuiFieldText
            name="innovatorName"
            inputRef={register({ required: true })}
            isInvalid={errors.innovatorName && true}
            fullWidth
          />
        </EuiFormRow>

        <EuiFormRow
          label="NRC Number"
          helpText="Enter your NRC, i.e., 123456/78/9."
          fullWidth
        >
          <EuiFieldText
            name="nrcNumber"
            inputRef={register({ required: true })}
            fullWidth
          />
        </EuiFormRow>

        <EuiFormRow
          label="Contact Number"
          helpText="Your primary contact number."
          fullWidth
        >
          <EuiFieldText
            name="contact"
            inputRef={register({ required: true })}
            fullWidth
          />
        </EuiFormRow>

        <EuiFormRow label="Alternative Contact Number" fullWidth>
          <EuiFieldText
            name="altContact"
            inputRef={register({ required: true })}
            fullWidth
          />
        </EuiFormRow>

        <EuiFormRow label="Email address" fullWidth>
          <EuiFieldText
            name="email"
            inputRef={register({ required: true })}
            fullWidth
          />
        </EuiFormRow>

        <EuiFormRow label="Business physical address" fullWidth>
          <EuiFieldText
            name="businessAddress"
            inputRef={register({ required: true })}
            fullWidth
          />
        </EuiFormRow>

        <EuiFormRow
          label="Select which category applies to you"
          isInvalid={categoryErrors}
          helpText="Choose as appropriate"
          fullWidth
        >
          <EuiSuperSelect
            options={categoryOptions}
            valueOfSelected={category}
            isInvalid={categoryErrors}
            fullWidth
            onChange={(value: any) => setCategory(value)}
          />
        </EuiFormRow>
        <EuiText grow={false}>
          <EuiSpacer />
          <h2>Proposed Project</h2>
          <hr />
          <EuiSpacer />
        </EuiText>

        <EuiFormRow
          label="What is the nature of the project (ICT)/Digital Innovations/Solutions in)"
          isInvalid={nopErrors}
          fullWidth
        >
          <EuiComboBox
            fullWidth
            placeholder="Select from the list"
            options={nopOptions}
            selectedOptions={selectedNopOptions}
            onChange={onNopChange}
            isInvalid={nopErrors}
            isClearable={true}
            data-test-subj="demoComboBox"
          />
        </EuiFormRow>

        <EuiFormRow
          label="Project Description"
          helpText="Maximum of 200 words."
          fullWidth
        >
          <EuiTextArea
            name="description"
            placeholder="Give a brief description on what your project is and what problem is being solved or process being improved"
            inputRef={register({ required: true })}
            fullWidth
          />
        </EuiFormRow>

        <EuiFormRow
          label="Innovation of Idea/Invention"
          helpText="Maximum of 200 words."
          fullWidth
        >
          <EuiTextArea
            name="innovation"
            placeholder="Give a brief description of what your innovation is and what problem is being solved or process beign improved."
            inputRef={register({ required: true })}
            fullWidth
          />
        </EuiFormRow>

        <EuiFormRow
          label="Technical Feasibility of the Innovation"
          helpText="Maximum of 200 words."
          fullWidth
        >
          <EuiTextArea
            name="feasibility"
            placeholder="Explain how your project is designed and what prototype exists if any"
            inputRef={register({ required: true })}
            fullWidth
          />
        </EuiFormRow>

        <EuiFormRow
          label="Usefulness of the project"
          helpText="Maximum of 200 words."
          fullWidth
        >
          <EuiTextArea
            name="usefulness"
            placeholder="How useful is the product to uplifting living standard, explain how applicable your product or service is to daily life."
            inputRef={register({ required: true })}
            fullWidth
          />
        </EuiFormRow>

        <EuiFormRow
          label="Commercial Viability of the Innovation"
          helpText="Maximum of 200 words."
          fullWidth
        >
          <EuiTextArea
            name="viability"
            placeholder="Explain how your innovation will generate income for you or others or how it can assist in improving operations of existing businesses, specify your target market/potential offtakers"
            inputRef={register({ required: true })}
            fullWidth
          />
        </EuiFormRow>

        <EuiFormRow
          label="Anticipated Social Impact"
          helpText="Maximum of 200 words."
          fullWidth
        >
          <EuiTextArea
            name="socialImpact"
            placeholder="Explain how your innovation can improve the lives of others"
            inputRef={register({ required: true })}
            fullWidth
          />
        </EuiFormRow>

        <EuiFormRow
          label="Team Composition"
          helpText="Maximum of 200 words."
          fullWidth
        >
          <EuiTextArea
            name="teamComposition"
            placeholder="Relevant industry experience, entrepreneurial track record, eduction, access to resource, etc."
            inputRef={register({ required: true })}
            fullWidth
          />
        </EuiFormRow>

        <EuiFormRow
          label="Partnerships"
          helpText="Maximum of 200 words."
          fullWidth
        >
          <EuiTextArea
            name="partnerships"
            placeholder="Include relevant partnerships to enhance the innovation."
            inputRef={register({ required: true })}
            fullWidth
          />
        </EuiFormRow>

        <EuiFormRow
          label="Risk management"
          helpText="Maximum of 500 words."
          fullWidth
        >
          <EuiTextArea
            name="risks"
            placeholder="Describe the risks, their likeliness of occurrence, and how you plan to mitigate them."
            inputRef={register({ required: true })}
            fullWidth
          />
        </EuiFormRow>

        <EuiFormRow
          label="What is the intellectual property status of the project?"
          isInvalid={ipErrors}
          helpText="Choose as appropriate"
          fullWidth
        >
          <EuiSuperSelect
            options={ipOptions}
            valueOfSelected={ip}
            isInvalid={ipErrors}
            fullWidth
            onChange={(value: any) => setIp(value)}
          />
        </EuiFormRow>

        <EuiFormRow
          label="What is the current stage of the project?"
          isInvalid={stageErrors}
          helpText="Choose as appropriate"
          fullWidth
        >
          <EuiSuperSelect
            options={stageOptions}
            valueOfSelected={stage}
            isInvalid={stageErrors}
            fullWidth
            onChange={(value: any) => setStage(value)}
          />
        </EuiFormRow>

        <EuiFormRow
          label="Supporting Image"
          helpText="Add an image to support your innovation"
          fullWidth
        >
          <EuiFilePicker
            fullWidth
            accept="image/x-png,image/gif,image/jpeg"
            onChange={(files) => {
              onImageChange(files);
            }}
          />
        </EuiFormRow>
        <EuiText grow={false}>
          <EuiSpacer />
          <h2>Financials</h2>
          <hr />
          <EuiSpacer />
        </EuiText>
        <EuiFormRow
          label="What is the total project cost"
          helpText="Total cost may include owner's contribution."
          fullWidth
        >
          <EuiFieldNumber
            name="totalCost"
            inputRef={register({ required: true })}
            fullWidth
          />
        </EuiFormRow>
        <EuiFormRow
          label="How much are your applying for from the TBDF?"
          fullWidth
        >
          <EuiFieldNumber
            name="appliedAmount"
            inputRef={register({ required: true })}
            fullWidth
          />
        </EuiFormRow>
        <EuiFormRow
          label="Proof of matching funds"
          helpText="Maximum of 200 words."
          fullWidth
        >
          <EuiTextArea
            name="fundsProof"
            placeholder="Where the total cost is higher than the request amount, show how you will meet the difference between total project cost and funds requested from the TDBF"
            inputRef={register({ required: true })}
            fullWidth
          />
        </EuiFormRow>
        <EuiFormRow
          label="What is the purpose of the TBDF financial support"
          isInvalid={purposeErrors}
          helpText="Choose as appropriate"
          fullWidth
        >
          <EuiSuperSelect
            options={purposeOptions}
            valueOfSelected={purpose}
            isInvalid={purposeErrors}
            fullWidth
            onChange={(value: any) => setPurpose(value)}
          />
        </EuiFormRow>
        <EuiFormRow
          label="NRC Copy"
          helpText="Upload a copy of your NRC"
          fullWidth
        >
          <EuiFilePicker
            fullWidth
            accept="image/x-png,image/gif,image/jpeg"
            onChange={(files) => {
              onNRCChange(files);
            }}
          />
        </EuiFormRow>

        <EuiFormRow
          label="Company of Business name registration"
          helpText="Upload a copy of your company or business name registration"
          fullWidth
        >
          <EuiFilePicker
            fullWidth
            accept="image/x-png,image/gif,image/jpeg"
            onChange={(files) => {
              onRegChange(files);
            }}
          />
        </EuiFormRow>

        <EuiFormRow
          label="Upload Intellectual Property Protection Certificate"
          helpText="Upload a copy of your Intellectual Protection Certificate if you have one."
          fullWidth
        >
          <EuiFilePicker
            fullWidth
            accept="image/x-png,image/gif,image/jpeg"
            onChange={(files) => {
              onIpChange(files);
            }}
          />
        </EuiFormRow>
        <EuiSpacer />
        <EuiSpacer />
        <EuiText size="xs">
          <h2>Disclaimer</h2>
          <p>
            The information your provide in this application is used when
            processing and assessing your submission. Summary information
            provided by all applications will be stored at NTBC and remains the
            property of the Centre. The information your have provided including
            personal information, may be used by the Centre to contact you by
            the Centre or organizations which are support similar programmes,
            and may be made public through national and local media via the NTBC
            websites when deemed necessary for funding purposes.
          </p>
          <p>
            By clicking the submit button below, you declare thatn the
            information supplied above is true and correct to the best of your
            knowledge and belief.
          </p>
        </EuiText>
        <EuiSpacer />
        <div style={{ textAlign: "center" }}>
          <EuiButton fill type="submit" isLoading={loading}>
            <EuiText>Submit Project</EuiText>
          </EuiButton>
        </div>
      </EuiForm>
    </div>
  );
};

export const ApplicationComplete: React.FC = () => {
  const payload = {
    recipient: localStorage.getItem("recipient"),
    greeting: "0762432603",
    recipeintsName: localStorage.getItem("recipeintsName"),
    subject: "something",
    message: "something",
  };
  useEffect(() => {
    axios.post("https://ntbc-mailer.herokuapp.com/send-email", payload);
  }, [payload]);
  return (
    <div>
      <EuiEmptyPrompt
        iconType="editorStrike"
        title={<h2>Your Application has be Submitted</h2>}
        body={
          <Fragment>
            <p>Thank you for submitting your application.</p>
            <p>
              For further queries, call, text, or whatsapp any one of these
              numbers: +260 954 235 099
            </p>
          </Fragment>
        }
        actions={
          <EuiButton
            color="primary"
            fill
            onClick={() => (window.location.href = "https://ntbc.co.zm")}
          >
            Continue
          </EuiButton>
        }
      />
    </div>
  );
};

function App() {
  useEffect(() => {
    localStorage.clear();
  }, []);
  return (
    <Switch>
      <Route path="/" component={NIIHome} exact />
      <Route path="/apply" component={ApplicationForm} exact />
      <Route path="/submitted" component={ApplicationComplete} />
      <Route path="/admin/login" component={AdminLogin} />
      <Route path="/admin/submissions" component={ApplicationSubmissions} />
      <Route />
    </Switch>
  );
}

export default App;
